<template>
    <modal v-if="showModal" @close="$emit('closeModal')">
        <template slot="header">
            <h4 class="modal-title">{{title}}</h4>
            <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="$emit('closeModal')">
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <md-field>
                <label>First Name</label>
                <md-input v-model="parent.first_name"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.first_name"/>

            <md-field>
                <label>Middle Name</label>
                <md-input v-model="parent.middle_name"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.middle_name"/>
            <md-field>
                <label>Last Name</label>
                <md-input v-model="parent.last_name"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.last_name"/>
            <md-field>
                <label>Phone</label>
                <md-input v-model="parent.phone_number"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.phone_number"/>
            <md-field>
                <label>Email</label>
                <md-input v-model="parent.email" type="email"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.email"/>


            <select-input
                    v-model="parent.parent_nature"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    label="name"
                    placeholder="Select Relation Type"
                    :options="relations"
                    :allow-empty="false"
                    :error="apiValidationErrors.parent_nature">
            </select-input>
            <select-input
                    v-model="parent.gender"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    label=""
                    placeholder="Select  gender"
                    :options="options"
                    :error="apiValidationErrors.gender"
                    :allow-empty="false">
            </select-input>

            <select-input
                    v-model="parent.status"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    label=" "
                    placeholder="Select Live Status"
                    :options="statues"
                    :allow-empty="false"
                    :error="apiValidationErrors.status"
            >
            </select-input>

            <select-input
                    v-model="parent.region_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label=" "
                    placeholder="Select Region"
                    :options="regions"
                    :allow-empty="false"
                    :error="apiValidationErrors.region_id"
            >
            </select-input>

            <select-input
                    v-if="parent.region_id"
                    v-model="parent.district_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label=" "
                    placeholder="Select District"
                    :options="districts"
                    :allow-empty="false"
                    :errors="apiValidationErrors.district_id"
            >
            </select-input>

            <select-input
                    v-if="parent.district_id"
                    v-model="parent.ward_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label="Districts"
                    placeholder="Select Ward"
                    :options="wards"
                    :allow-empty="false"
                    :error="apiValidationErrors.ward_id"
            >
            </select-input>

            <select-input
                    v-if="parent.ward_id"
                    v-model="parent.village_id"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label="Village / Street"
                    placeholder="Select Street"
                    :options="villages"
                    :allow-empty="false"
                    :error="apiValidationErrors.ward_id">
            </select-input>

            <select-input
                    v-if="parent.village_id"
                    v-model="parent.neighborhood_id"
                    track-by="id"
                    label="Neighborhood"
                    placeholder="Select Neighborhood"
                    :options="neighborhoods"
                    :allow-empty="true"
                    :error="apiValidationErrors.neighborhood_id"
            >
            </select-input>
            <md-field>
                <label>Address</label>
                <md-input v-model="parent.address"></md-input>
            </md-field>
            <validation-error :errors="apiValidationErrors.middle_name"/>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="add">Add Relative</md-button>
            <md-button
                    class="md-danger md-simple"
                    @click="$emit('closeModal')">Close
            </md-button>
        </template>
    </modal>
</template>

<script>
import {
    Modal
} from '@/components';
import SelectInput from '../Inputs/SelectInput';
import formMixin from '@/mixins/form-mixin';
import ValidationError from '../ValidationError';

export default {
    name: 'AddParentModal',
    components: { SelectInput, Modal,ValidationError },
    mixins: [formMixin],
    props: {
        title: {
            type: String, default: 'Add role'
        },
        labourer: {
            type: Object
        },
        showModal: {
            type: Boolean, default: false
        },
        multiple: {
            type: Boolean, default: true
        },
        model: {
            type: String, default: ''
        },
        modelType: {
            type: String, default: 'skills/list'
        }
    },
    data () {
        return {
            selected: [],
            neighborhoods: [],
            villages: [],
            wards: [],
            districts: [],
            regions: [],
            parent: {},
            skills_config_options: [
                { id: '1', 'name': 'Yes' },
                { id: '0', 'name': 'No' }
            ],
            options: [
                { id: 'Female', 'name': 'Female' },
                { id: 'Male', 'name': 'Male' }
            ],
            statues: [
                { id: 'Alive', 'name': 'Alive' },
                { id: 'Deceased', 'name': 'Deceased' }
            ],
            relations: [
                { id: 'Mother', 'name': 'Mother' },
                { id: 'Father', 'name': 'Father' },
                { id: 'Guardian', 'name': 'Guardian' },
                { id: 'First Relative', 'name': 'First Relative' },
                { id: 'Second Relative', 'name': 'Second Relative' },
                { id: 'Referee', 'name': 'Referee' }
            ]
        };
    },
    created () {
        this.fetchData();
        this.resetParent();
    },
    methods: {

        async add () {
            try {
                this.parent.labourer_id = this.labourer.id;
                await this.$store.dispatch('labourerParents/add', this.parent);
                this.parent = this.$store.getters['labourerParents/labourerParent'];
                this.notifySuccess('Parent added successfully.');
                this.$emit('addParents', this.parent);
                this.resetParent();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        async fetchData () {
            await this.$store.dispatch('regions/list');
            this.regions = this.$store.getters['regions/list'];

            await this.$store.dispatch('districts/list');
            this.districts = this.$store.getters['districts/list'];
        },
        resetParent () {
            this.parent = {
                labourer_id : this.labourer.id,
                type: 'labourerParents',
                first_name: '',
                middle_name: '',
                last_name: '',
                gender: '',
                address: '',
                district_id: '',
                neighborhood_id: '',
                village_id: '',
                ward_id: '',
                region_id: '',
            };
        }
    },
    computed: {
        // filteredDistricts() {
        //     return (region) => this.districts.filter((district) => {
        //         console.log(district.region_id)
        //         console.log(region)
        //         return district.region_id == region;})
        // },
        village () {
            return this.parent.village_id;
        },
        ward () {
            return this.parent.ward_id;
        },
        district () {
            return this.parent.district_id;
        },
        region () {
            return this.parent.region_id;
        },
    },
    watch: {
        async region () {
            await this.$store.dispatch('regions/get', this.parent.region_id);
            let region = this.$store.getters['regions/region'];
            this.districts = region.districts;
        },
        async village () {
            await this.$store.dispatch('villages/get', this.parent.village_id);
            this.neighborhoods = this.$store.getters['villages/village'].neighborhoods;
        },
        async ward () {
            await this.$store.dispatch('wards/get', this.parent.ward_id);
            let ward = this.$store.getters['wards/ward'];
            this.villages = ward.villages;
        },
        async district () {
            await this.$store.dispatch('districts/get', this.parent.district_id);
            let district = this.$store.getters['districts/district'];
            this.wards = district.wards;
        },
    }
};
</script>

<style scoped>

</style>
